import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IPbiReport, IPbiDataset } from '../business-objects/types';

// types
export enum PbiAdminActionTypes {
  SEARCH = 'PBI_SEARCH',
  SAVENEW = 'SAVENEW',
  SETACTIVEREPORT = 'SETACTIVEREPORT',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  GET_DATASETS = 'GET_DATASETS',
}

export const DoPbiAdminSearch = (url: string) => (dispatch) =>
  new Promise<void>(function (resolve, reject) {
    Api.get(url)
      .then((result: ApiResponse<any>) => {
        dispatch(reducePbiResults(result.data));
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reducePbiResults = (result: IPbiReport[]) => {
  return {
    type: PbiAdminActionTypes.SEARCH,
    value: result,
  };
};

export const GetDatasets = (url: string) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.get(url)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceDatasets(result.data));
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceDatasets = (result: IPbiDataset[]) => {
  return {
    type: PbiAdminActionTypes.GET_DATASETS,
    value: result,
  };
};

export const SaveNewReport = (url: string, report: IPbiReport) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.post(url, report)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceSave(result.data));
        resolve(result);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceSave = (result: IPbiReport) => {
  return {
    type: PbiAdminActionTypes.SAVENEW,
    value: result,
  };
};

export const SetActiveReport = (report: IPbiReport) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch(reduceActiveReport(report));
    resolve(report);
  });

export const reduceActiveReport = (report: IPbiReport) => {
  return {
    type: PbiAdminActionTypes.SETACTIVEREPORT,
    value: report,
  };
};

export const SaveEditReport = (url: string, report: IPbiReport) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.post(url, report)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceEdit(result.data));
        resolve(result);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const SaveReportSharing = (url: string, report: IPbiReport) => (
  dispatch
) =>
  new Promise(function (resolve, reject) {
    Api.post(url, report)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceEdit(result.data));
        resolve(result);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceEdit = (result: IPbiReport) => {
  return {
    type: PbiAdminActionTypes.EDIT,
    value: result,
  };
};

export const DeleteReport = (url: string, report: IPbiReport) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.post(url, report)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceDelete(result.data));
        resolve(result);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceDelete = (result: IPbiReport) => {
  return {
    type: PbiAdminActionTypes.DELETE,
    value: result,
  };
};
